import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useEffect, useState } from 'react';
import { getPatientById, getAccountByPatientId } from '../api';
import { useParams } from 'react-router-dom';
import { EditAccount } from '../Components/PatientsAccounts/EditAccounts';
import { PrevSessions } from '../Components/Sessions/PrevSessions';


export function Patients() { 
    const [patient, setPatient] = useState([]);
    const [account, setAccount] = useState([]);
    const { id } = useParams();
    const [activeSection, setActiveSection] = useState("account");
    const [modalShow, setModalShow] = useState(false);
    

    useEffect(() => {
      async function loadPatient() {
        try {
          const data = await getPatientById(id);
          setPatient(data);
    
          // Load account only if patient data is successfully fetched
          if (data && data._id) {
            await loadAccount(data._id);
          } else {
            console.error("Patient data is missing or invalid.");
          }
        } catch (error) {
          console.error("Error fetching patient data:", error);
        }
      }
    
      async function loadAccount(patientId) {
        try {
          const accountData = await getAccountByPatientId(patientId);
          setAccount(accountData);
        } catch (error) {
          console.error("Error fetching account data:", error);
        }
      }
    
      loadPatient();
    }, [id]); // Include 'id' in the dependency array
    
    function renderPatientInfo() {
      if (!patient || !patient._id) {
        return <p>Loading patient information...</p>;
      }
    
      return (
        <div>
          <Row className="mb-2">
          <strong>{patient.patientTitle} {patient.patientFullNames} {patient.patientLastName} ({patient.patientFirstName})</strong>
          </Row>
          
          <Row>
            <Col md={7}>
            <i className="fa-regular fa-hashtag me-2 text-primary"></i> {patient.patientNumber}
              <i className="fa-solid fa-id-card me-1 text-primary"></i>  {patient.patientIdNumber} <br/>
              <i className="fas fa-phone-alt me-2 text-primary"></i> {patient.patientCellNumber} <br/>
              <i className="fas fa-envelope me-2 text-primary"></i> {patient.patientEmail} <br/>
            </Col>
            <Col md={5}>
              <i className="fa-solid fa-venus-mars text-primary"></i> {patient.patientGender} <br/>
              <i className="fa fa-language text-primary"></i> {patient.patientHomeLanguage} <br/>
            </Col>
            </Row>
            </div>
      );
    };   

    function renderAccountInfo() {
      if (!account || !account._id) {
        return <p>Loading account information...</p>;
      }
    
      return (
        <div>
          <Row className="mb-2">
          <strong>{account.accountTitle} {account.accountFullNames} {account.accountLastName} ({account.accountFirstName})</strong>
          </Row>
          
          <Row>
            <Col md={4}>
            <i className="fa-regular fa-hashtag me-2 text-primary"></i> {account.accountNumber}
              <i className="fa-solid fa-id-card me-1 text-primary"></i>  {account.accountIdNumber} <br/>
              <i className="fas fa-phone-alt me-2 text-primary"></i> {account.accountCellNumber} <br/>
              <i className="fas fa-envelope me-2 text-primary"></i> {account.accountEmail} <br/>
            </Col>
            
            <Col md={4}>
            <i className="fas fa-map-marker-alt me-2 text-primary"></i>{account.accountPostalAddress1} <br/>
            <i className="fas fa-city me-2 text-white"></i>{account.accountPostalAddress2} <br/>
            <i className="fas fa-city me-2 text-white"></i>{account.accountPostalAddressCity}, {account.accountPostalAddressPostalCode} <br/>
            </Col>
            <Col md={4}>
            <i className="fas fa-briefcase me-2 text-primary"></i>{account.accountOccupation} <br/>
            <i className="fas fa-building me-2 text-primary"></i>{account.accountEmployer} <br/>
            <i className="fas fa-phone-alt me-2 text-primary"></i>{account.accountTelNumberWork} <br/>
            </Col>
            </Row>
            </div>
      );
    };   

    function renderMedicalAidInfo() {
      if (!patient.accountMedicalAid) {
        return (
          <Row className="mb-3">
          <p>
            <i className="fa-solid fa-notes-medical me-2 text-primary"></i>None <br />
            <i className="fas fa-city me-2 text-white"></i><br />
            <i className="fas fa-city me-2 text-white"></i><br />
            </p>
        </Row> 
           
        );
      }
      return (
        <div>
        <Col md={4}>
            <p>
              <i className="fa-solid fa-notes-medical text-primary"></i>{account.accountMedicalAid} <br />
              <i className="fas fa-city me-2 text-white"></i>{patient.patientMedicalAidPlan} <br />
              <i className="fas fa-city me-2 text-white"></i>{patient.patientMedicalAidNumber}
              </p>
            </Col>
            <Col md={8}>
              <i className="fas fa-notes-medical">Benefits</i>
            </Col>  
            </div>
      );
    }; 
  
    return (
      <div>
        <Row className="me-3 ms-3 mb-3" style={{ marginTop: "65px" }} >
          <Col md={4}>
            <div className="container mt-3 border border-secondary rounded pt-2">
              {/* Add consistent spacing */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="fw-normal text-primary">Patient Information</h5>
             
              </div>
              <Row className="ms-1 mb-3">{renderPatientInfo()}</Row>
            </div>
          </Col>
          <Col md={8}>
            <div className="container mt-3 border border-secondary rounded pt-2">
              {/* Add consistent spacing */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex align-items-center">
                  {/* Account Information Heading */}
                  <h5
                    className={`fw-normal text-primary d-inline me-2 ${
                      activeSection === "account" ? "text-primary fw-normal" : "text-secondary fw-light"
                    }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => setActiveSection("account")}
                  >
                    Account Information
                  </h5>

                  {/* Separator */}
                  <span className="text-secondary mx-3 pb-2">|</span>

                  {/* Medical Aid Information Heading */}
                  <h5
                    className={`fw-normal text-primary d-inline ${
                      activeSection === "medicalAid" ? "text-primary fw-normal" : "text-secondary fw-light"
                    }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => setActiveSection("medicalAid")}
                  >
                    Medical Aid Information
                  </h5>
                </div>
                <EditAccount
                  show={modalShow}
                  onHide={() => setModalShow(false)} 
                  patientId={id}
                />
              </div>

              <Row className="ms-1 mb-3">
                {/* Conditionally Render Based on Active Section */}
                {activeSection === "account" && renderAccountInfo()}
                {activeSection === "medicalAid" && renderMedicalAidInfo()}
              </Row>
            </div>
          </Col>
        </Row>
        <hr />
        <PrevSessions />
      </div>


    );
   };